import { getEnvVar } from "../platform";

/**
 * Read a build-time env var. Delegates to the configured platform adapter
 * so the same code works on Vite (web/desktop) and Metro (mobile).
 */
export function getEnv(key: string, fallback: string): string {
  return getEnvVar(key, fallback);
}
